import { c as _c } from "react/compiler-runtime";
import type { GetHistoryEntry } from '@repo/schema/history';
import { DateFormatter } from '@repo/ui/date-formatter';
const getActorName = (entry: GetHistoryEntry) => {
  if (entry.is_system) return 'System';
  return `${entry.user.name}${entry.user.last_name ? ` ${entry.user.last_name}` : ''}`;
};
export const ActorMeta = t0 => {
  const $ = _c(15);
  const {
    entry
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="sr-only">Changed by: </span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== entry) {
    t2 = getActorName(entry);
    $[1] = entry;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <span>{t2}, </span>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== entry.created_at) {
    t4 = entry.created_at.toISOString();
    $[5] = entry.created_at;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== entry.created_at) {
    t5 = <DateFormatter date={entry.created_at} kind="time" data-sentry-element="DateFormatter" data-sentry-source-file="history-actor-meta.tsx" />;
    $[7] = entry.created_at;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <time dateTime={t4}>{t5}</time>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t3 || $[13] !== t6) {
    t7 = <div className="min-w-0 text-right text-sm leading-5 break-words text-muted-foreground @xl/history:text-base @xl/history:leading-6" data-sentry-component="ActorMeta" data-sentry-source-file="history-actor-meta.tsx">{t1}{t3}{t6}</div>;
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};